export default __webpack_public_path__ + "static/media/118100300_fair-reisen.52eeb703.jpeg";